import { render } from "./MenuHome.vue?vue&type=template&id=3df9e8fb&scoped=true&lang=html"
import script from "./MenuHome.vue?vue&type=script&lang=js"
export * from "./MenuHome.vue?vue&type=script&lang=js"

import "./MenuHome.vue?vue&type=style&index=0&id=3df9e8fb&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df9e8fb"]])

export default __exports__